import { InjectionToken } from '@angular/core';

export const VERSION = new InjectionToken<string>('Version');
export const VERSION_NAME = new InjectionToken<string>('Version name');
export const DEPLOY_URL = new InjectionToken<string>('DeployUrl');
